import React, { useContext } from 'react';
import { signUpContext } from '../../../pages/signup';
import BlueButton from '../../../components/ui/BlueButton';
import { Formik, Form, ErrorMessage, Field } from "formik";
import * as Yup from "yup";
import styles from './SignUpDetails.module.css';
import useAuth from '../../../hooks/useAuth';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom'; 



const SignUpDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const from = location.state?.from?.pathname;


    const { Mail,Page } = useContext(signUpContext);
    useAuth();
    const initialValues = {
      password: "",
      cpassword: "",
      name: "",
    };

    const onSubmit = (values) => {
      console.log("onSubmit", values);
      const data1 = { name: values.name, email: Mail, password: values.password, status: Page, cin: (Math.random() + 1).toString(36).substring(7) };
      console.log(data1);
      
      axios({
        method: 'post',
        url: `${process.env.REACT_APP_HOST1}/auth/`,
        data: data1,
        headers: {
          "Content-Type": "application/json"
        }
      }).then((response) => {
        
        console.log("Response:", response.data);
        navigate(from, { replace: true }); 
      }).catch((error) => {
        alert(error.response.data.details)
        console.error("Error:", error);
      });
    

    };


  
    const validationSchema = Yup.object({
        password: Yup.string()
            .min(8, 'Password must be at least 8 characters')
            .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
            .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
            .matches(/[0-9]/, 'Password must contain at least one digit')
            .matches(/[@$!%*?&]/, 'Password must contain at least one special character')
            .required('Password is required'),
        name: Yup.string().required('Name is required'),
        cpassword: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match'),
    });
    
    return (<>             
      <h1>Create a Password</h1>
      <div className={styles.container}>
        
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {() => (
            <Form>
                {/* is itusername or name ? */}
                <div >
                    <Field className={styles.input} name="name" placeholder="Name" />
                    <div className={styles.error}>
                        <ErrorMessage name="name" component="span" />
                    </div>
                </div>    

                <div >
                    <Field className={styles.input} name="password" placeholder="Password" type="password" />
                    <div className={styles.error}>
                        <ErrorMessage name="password" component="span" />
                    </div>
                </div>
                <div >
                    <Field className={styles.input} name="cpassword" placeholder="Confirm Password" type="password" />
                    <div className={styles.error}>
                        <ErrorMessage name="cpassword" component="span" />
                    </div>
                </div>
              <BlueButton extraStyle={{width: '100%'}}type={'submit'}><p>SignUp</p></BlueButton>
            </Form>
          )}
        </Formik>
      </div>
        </>
        )
  }

export default SignUpDetails;